export class Submit {
  public static readonly type = '[Chat] Submit';
}
